<template>
    <div>
        <el-input
            v-if="mode == 'edit'"
            v-model="currentValue"
            :placeholder="placeholder"
            :data-bot="dataBot"
            @change="update"
            @blur="formatAmount"
        >
            <template v-if="numberFormat.currencypos == 'right'" slot="append">{{
                symbol
            }}</template>
            <template v-if="numberFormat.currencypos == 'left'" slot="prepend">{{
                symbol
            }}</template>
        </el-input>
        <p v-else>{{ currentValue }} {{ numberFormat.currencysymbol }}</p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        value: {
            type: [Number, String],
            required: false,
            default: 0,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        symbol: {
            type: String,
            required: false,
            default: window.App.numformat.currencysymbol,
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            numberFormat: window.App.numformat,
            currentValue: this.value,
        };
    },
    created() {
        this.currentValue = NumberFormat.formatToDisplay(this.value, window.App.numformat);
    },
    methods: {
        formatAmount() {
            if (!this.currentValue) {
                this.currentValue = 0;
            }
            this.currentValue = NumberFormat.formatToDisplay(this.currentValue, this.numberFormat);
        },
        update(newVal) {
            this.$emit('input', newVal);
        },
    },
};
</script>
